import type {
  EmcComplianceFileAttachment,
  EmcComplianceFileSlotAttachmentsView,
} from '@/shared/hooks/api/emcProductComplianceFileAttachments'
import { isEmcComplianceFileSlotFilled } from '@/shared/hooks/api/emcProductComplianceFileAttachments'

export type EmcTechnicalDrawingsLegacySlotKind = 'DESCRIPTIONS_AND_EXPLANATIONS'

export type EmcTechnicalDrawingsEvidenceFile = EmcComplianceFileAttachment & {
  deleteSlotKind: 'DRAWINGS_SCHEMAS' | EmcTechnicalDrawingsLegacySlotKind
}

export function isEmcTechnicalDrawingsEvidenceFilled(
  drawings: EmcComplianceFileSlotAttachmentsView | undefined,
  legacyDescriptionsAndExplanations:
    | EmcComplianceFileSlotAttachmentsView
    | undefined
): boolean {
  return (
    isEmcComplianceFileSlotFilled(drawings) ||
    isEmcComplianceFileSlotFilled(legacyDescriptionsAndExplanations)
  )
}

export function mergeEmcTechnicalDrawingsEvidenceFiles(
  drawings: EmcComplianceFileSlotAttachmentsView | undefined,
  legacyDescriptionsAndExplanations:
    | EmcComplianceFileSlotAttachmentsView
    | undefined
): EmcTechnicalDrawingsEvidenceFile[] {
  const merged: EmcTechnicalDrawingsEvidenceFile[] = []
  for (const file of drawings?.files ?? []) {
    merged.push({ ...file, deleteSlotKind: 'DRAWINGS_SCHEMAS' })
  }
  for (const file of legacyDescriptionsAndExplanations?.files ?? []) {
    merged.push({
      ...file,
      deleteSlotKind: 'DESCRIPTIONS_AND_EXPLANATIONS',
    })
  }
  return merged
}
